<template>
<div class='vue-form'>

  <b-jumbotron header-level='5' style="margin-bottom: .75em;">
    <p v-html="intro.title" class="lead" style="margin: 0; font-weight: 500; font-size: 1.7em; margin-bottom: .2em;"></p>
    <!-- <p v-html="intro.desc" class="lead" style="margin: 0"></p> 
    <p class="lead" style="margin: 0; font-weight: 500; font-size: 1.4em; margin-bottom: .2em;"></p> -->
    <p class="lead" style="margin: 0; font-size: 1.2em">In-person Session at South Dakota Mines<br />May 13, 2026 (One-day only)<br />Nucor Mineral Industries Building, Room 246</p>
	<p class="lead" style="margin-top: 1em; font-size: 1.2em">AI isn’t the future — it’s now. This dynamic session cuts through the hype and gives you the honest truth about how artificial intelligence is transforming productivity across industries.</p>
  </b-jumbotron>

  <form ref='form' :action='results.action' method='post' @submit='onSubmit' name="vfm" enctype="multipart/form-data">
    <input type='hidden' name='post' :value='results.post' />
    <input type='hidden' name='CourseName' value='Minining Industry Primer' />
    <!-- <div class='email_field_group' v-for='email, index in this.emails'>
      <input type='hidden' :name='"email_" + (index+1).toString()+ "_from_name"' :value='email.from_name' />
      <input type='hidden' :name='"email_" + (index+1).toString()+ "_from"' :value='email.from' />
      <input v-if='(email.to === "self")' type='hidden' :name='"email_" + (index+1).toString()+ "_to"' :value='items.vfm_email.data'  />
      <input v-else type='hidden' :name='"email_" + (index+1).toString()+ "_to"' :value='email.to' />
      <input type='hidden' :name='"email_" + (index+1).toString()+ "_subject"' :value='email.subject' />
      <input type='hidden' :name='"email_" + (index+1).toString()+ "_body"' :value='emails[index].body' />
    </div> -->

    <div class='email_field_group'>
      <input type='hidden' :name='"email_1_from_name"' :value='results.emails[0].from_name' />
      <input type='hidden' :name='"email_1_from"' :value='results.emails[0].from' />
      <input type='hidden' :name='"email_1_to"' :value='results.emails[0].to' />
      <input type='hidden' :name='"email_1_subject"' :value='results.emails[0].subject' />
      <input type='hidden' :name='"email_1_body"' :value='email_1_body' />
    </div>

    <div class='email_field_group'>
      <input type='hidden' :name='"email_2_from_name"' :value='results.emails[1].from_name' />
      <input type='hidden' :name='"email_2_from"' :value='results.emails[1].from' />
      <input type='hidden' :name='"email_2_to"' :value='items.vfm_email.data' />
      <input type='hidden' :name='"email_2_subject"' :value='results.emails[1].subject' />
      <input type='hidden' :name='"email_2_body"' :value='email_2_body' />
    </div>

    <!-- <div v-if='pmt === "PC"' class='email_field_group'>
      <input type='hidden' :name='"email_3_from_name"' :value='results.emails[0].from_name' />
      <input type='hidden' :name='"email_3_from"' :value='results.emails[0].from' />
      <input type='hidden' :name='"email_3_to"' :value='meta.poc_email2' />
      <input type='hidden' :name='"email_3_subject"' :value='meta.form_name + " Submission - Exempt Payment"' />
      <input type='hidden' :name='"email_3_body"' :value='results.emails[0].body' />

      <input type='hidden' name="file_1_attachments" value="3" />
      <input type='hidden' name="file_1_upload" value="N" />
    </div> -->

    <div class='csv_field_group' v-for='csv, f_index in this.csv_files'>
      <input type='hidden' :name='"csv_"+(f_index+1).toString()+"_file"' :value='"/upload/results/"+csv.path+csv.file' />
      <input v-for='item, key, i_index in items' :key='key' :name='csvEnum(item.name, f_index, i_index)' type='hidden' :value='getCSVValue(csv.omit, key)' />
      <input :name='stampEnum(f_index)' type='hidden' value='Stamp' />
    </div>

    <input type='hidden' name='PaymentAmount' :value='meta.tot_amount.toFixed(2)' />
    <input type='hidden' name='PaymentDescription' :value='pmt_description' />
<!--    <input type='hidden' name='FeeSubtotal' :value='registration_fee.toFixed(2)' />
    <input type='hidden' name='Tax' :value='tax_fee' />
    <input type='hidden' name='FeeTotal' :value='total_fee' />-->
    <input type='hidden' name='PmtType' :value='pmt'/>
    <input type='hidden' name='Account' :value='meta.pmt_account' />
<!--    <input type='hidden' name='Enroll' :value='results.enroll' />-->
    <input type='hidden' name='Stamp' :value='results.stamp' />
    <input type='hidden' name='confirm' :value='confirmURL' />
    <input type='hidden' name='confirm_template' :value='confirm_template'  />
    <div class='miners'>
      <label>hidden
      <input class='miners' name='miners' value='' />
      </label>
    </div>

    <!-- <b-modal v-model='meta.closed'>This form is now closed.</b-modal> -->

    <div class='vfm_item' v-for='item, key in items'>
      <div v-if="item.section_header">
        <h4>{{ item.section_header }}</h4>
      </div>
      <div v-if="item.name === 'RegisterCourse'">
        <h6>{{ item.program }}</h6>
        <h6>{{ item.schedule_header }}</h6>
        <p style="margin-left: 20px;">{{ item.schedule_info }}</p>
      </div>
      <b-form-group v-if='((item.type === "radio"))' v-show='item.show' :label-for='item.name' :description='item.help'>
        <label>{{ item.label }}
        <b-form-radio-group stacked v-model='item.data' v-on:input='radioTrig(key, item.ctrl, item.data)' :name='item.name' :options='item.init.options'></b-form-radio-group>

        <input hidden type='radio' :name='item.name' v-validate='item.reqs' :class='{"is-danger":errors.has(item.name)}' />
        </label>

        <div v-show="errors.has(item.name)" class='danger is-danger'>{{errors.first(item.name)}}</div>
      </b-form-group>

      <b-form-group v-else-if='((item.type === "select"))' v-show='item.show' :label='item.label' :label-for='item.name' :description='item.help'>
        <b-form-select v-model='item.data' :name='item.name' :options='vfm_init(key)' v-validate='item.reqs' data-vv-validate-on='change' :class='{"is-danger":errors.has(item.name)}'>
        </b-form-select>
        <div v-show="errors.has(item.name)" class='danger is-danger'>{{errors.first(item.name)}}</div>
      </b-form-group>

      <b-form-group v-else-if='((item.type === "checkbox"))' v-show='item.show' :label-for='item.name'>
        <b-form-checkbox v-model='item.data' :name='item.name' unchecked-value='' value='item.value' v-validate='item.reqs'> {{ item.label }}
        </b-form-checkbox>
        <div v-show="errors.has(item.name)" class='danger is-danger'>{{errors.first(item.name)}}</div>
      </b-form-group>

      <b-form-group v-else-if='(item.type === "textarea")' v-show='item.show' :label-for='item.name' :description='item.help'>
        <label style="width: 100%">{{ item.label }}
        <b-form-textarea v-model='item.data' :name='item.name' :placeholder='item.init.placeholder' :rows='5' :max-rows='10' :state="item.data.length <=250" v-validate='item.reqs' :class='{"is-danger":errors.has(item.name)}'></b-form-textarea>
        <span v-if='item.reveal'>
          <b-btn variant='link' size='sm' v-show='(item.reveal && !items[item.reveal.target].show)' v-on:click='clickReveal(item)'>{{item.reveal.text}}</b-btn>
        </span>
        <span v-if='(item.hide && item.reveal)'>
          <b-btn variant='link' size='sm' v-show='(item.hide && !items[item.reveal.target].show)' v-on:click='clickHide(item)'>
            {{item.hide.text}}
          </b-btn>
        </span>
        <span v-if='(item.hide && typeof(item.reveal) === "undefined")'>
          <b-btn variant='link' size='sm' v-show='item.hide' v-on:click='clickHide(item)'>
             {{item.hide.text}}
           </b-btn>
        </span>
        </label>
        
        <div v-show="errors.has(item.name)" class='danger is-danger'>{{errors.first(item.name)}}</div>
      </b-form-group>

      <!-- <b-form-group v-else-if='(item.type === "textarea")' v-show='item.show' :label='item.label' :label-for='item.name' :description='item.help'>
        <b-form-textarea v-model='item.data' :name='item.name' :placeholder='item.init.placeholder' :rows='5' :max-rows='10' v-validate='item.reqs' :class='{"is-danger":errors.has(item.name)}'></b-form-textarea>
        <span v-if='item.reveal'>
          <b-btn variant='link' size='sm' v-show='(item.reveal && !items[item.reveal.target].show)' v-on:click='clickReveal(item)'>{{item.reveal.text}}</b-btn>
        </span>
        <span v-if='(item.hide && item.reveal)'>
          <b-btn variant='link' size='sm' v-show='(item.hide && !items[item.reveal.target].show)' v-on:click='clickHide(item)'>
            {{item.hide.text}}
          </b-btn>
        </span>
        <span v-if='(item.hide && typeof(item.reveal) === "undefined")'>
          <b-btn variant='link' size='sm' v-show='item.hide' v-on:click='clickHide(item)'>
             {{item.hide.text}}
           </b-btn>
        </span>
        <div v-show="errors.has(item.name)" class='danger is-danger'>{{errors.first(item.name)}}</div>
      </b-form-group> -->

      <b-form-group v-else-if='(item.type === "link")' v-show='item.show' :description='item.help'>
        <span v-html='item.label'></span>
      </b-form-group>

      <b-form-group v-else-if='(item.type === "currency")' v-show='item.show' :label='item.label' :label-for='item.name' :description='item.help'>
        <b-input-group prepend="$" append=".00">
          <b-form-input type='text' :name='item.name' :id='item.name' v-model='item.data' :placeholder='vfm_init(key)' v-validate='item.reqs' :class='{"is-danger":errors.has(item.name)}'></b-form-input>
        </b-input-group>
        <div v-show="errors.has(item.name)" class='danger is-danger'>{{errors.first(item.name)}}</div>
      </b-form-group>

      <b-form-group v-else v-show='item.show' :label='item.label' :label-for='item.name' :description='item.help'>
        <b-form-input :type='item.type' :name='item.name' :id='item.name' v-model='item.data' :placeholder='vfm_init(key)' v-validate='item.reqs' :class='{"is-danger":errors.has(item.name)}'></b-form-input>
        <div v-show="errors.has(item.name)" class='danger is-danger'>{{errors.first(item.name)}}</div>
      </b-form-group>
    </div>

    <b-form-group v-if='terms.show'>
         <b-form-checkbox id="terms" name="terms" v-model="terms.data" value="accepted" unchecked-value="" v-validate.initial="'required'">{{terms.label}}</b-form-checkbox>
    </b-form-group>

    <div>
      <h4>Payment Information</h4>
      <b-card class="pmt_summary">
      <h6>Invoice</h6>
      <b-row>
        <b-col cols="7" md="10">Course Registration</b-col>
        <b-col cols="5" md="2" align="right">$ 250.00</b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col cols="7" md="10">Total</b-col>
        <b-col cols="5" md="2" align="right">$ 250.00</b-col>
      </b-row>
    </b-card>
    </div>

    <b-form-group label='Payment Method'>
      <b-form-radio-group
        v-model="items.vfm_pmt_type.data"
        :options="pmt_options"
        name="payment" stacked>
      </b-form-radio-group>
    </b-form-group>

    <b-form-group id="certload" label="Please attach tax-exempt certification for P-card payments*" label-for="file_1" v-if='pmt === "PC"'>
      <b-form-file id="file_1" name="file_1" v-model='file' :state='Boolean(file)' placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." size="sm" v-validate.initial='"required"'></b-form-file>
      <div class="font-italic">
        Selected file: {{ file ? file.name : '' }}
      </div>
    </b-form-group>


    <!-- <b-form-group label='Select one or both recipients for your comments:'>
      <b-form-checkbox-group stacked id="recipients" name="recipients" v-model='email_1_to' v-validate="'required'">
        <b-form-checkbox id="recipient1" v-on:change='changeRecipient()' :value="meta.poc_email1">{{meta.poc_name1}}</b-form-checkbox>
        <b-form-checkbox id="recipient2" v-on:change='changeRecipient()' :value="meta.poc_email2">{{meta.poc_name2}}</b-form-checkbox>
      </b-form-checkbox-group>
    </b-form-group> -->

    <!-- <b-card>
      <p>
        <strong>{{ meta.policy_label }}</strong>: {{ meta.policy_text }}
      </p>
    </b-card> -->

    <!-- <hr /> -->
    <b-button :disabled='errors.any()' size='lg' type='submit' variant='dark'>Submit</b-button>
  </form>

  <div id="debug" class="debug" v-show="false">
    <h2>Debug</h2>
    <div>
      Errors = {{errors.any()}}<br /> {{errors.all()}}
    </div>
    <ul v-for='item in items'>
      <li>
        <div>{{item.name}}: <span class="data-debug">{{item.data}}</span></div>
        <div v-if='item.ctrl'>{{item.ctrl}}</div>
      </li>
    </ul>
    <div v-for='csv in csvPath_a'>
      {{csv.path}}
    </div>
    <div>
      {{ results.confirm }}
    </div>
  </div>

  <!-- <div id='confirm_template'>
    <b-row>
      <b-col><p>Thank you for submitting your input, which will be reviewed for further action steps.</p></b-col>
    </b-row>
    <hr />
    <b-row><strong>Submitted data:</strong></b-row>
    <b-row v-for="item in items" :key="item.name">
      <b-col cols="4"><strong>{{ item.label }}</strong></b-col>
      <b-col cols="8">{{ item.data }}</b-col>
    </b-row>
    <b-row><a href="https://www.sdsmt.edu/Campus-Life/Student-Complaint-Process">Back to Campus Life</a></b-row>
  </div> -->

  <div id="email_template_1" v-show="false">
  <!-- <div :id="'email_template_dept'+n" v-for="n in this.emails.length/2" v-show="true"> -->
    <hr />
    <div style=''>
      <table border="0" style="border-collapse: collapse; font: Arial normal 10pt ;" cellpadding="3">
        <tr>
            <td colspan="4">
               <p>This is an automated message to let you know that you have a new {{ meta.form_name }} submission.<br /><a :href="'https://interact.sdsmt.edu/' + meta.root + '/' + meta.sub + '/'">https://interact.sdsmt.edu/{{meta.root}}/{{ meta.sub }}/</a></p>

                <p>The link to the submission results file for this form is <a :href="'https://sdmines.sdsmt.edu/upload/results/' + csv_files[0].path + csv_files[0].file">https://sdmines.sdsmt.edu/upload/results/{{ csv_files[0].path }}{{ csv_files[0].file }}</a>. Remember, this file may contain personally identifiable information from previous submissions, so please do not share this link.</p>

               <p>If you have any trouble accessing the data you've received from this submission, please contact <a href="mailto:vickie.bender@sdsmt.edu">ITS</a>.</p>
            </td>
        </tr>
      </table>
      <hr />
      <h4>Submission Information</h4>
      <hr />
      <table>
        <tr><td></td></tr>
          <tr v-for="item in items" :key="item.name">
            <td style="vertical-align:top; width: 50%;"><b>{{ item.label }}</b></td>
            <td v-if="item.type === 'currency'" style="vertical-align:top; text-align: right; border-top: 1px solid; border-bottom: double">{{ Number(item.data) | currency }}</td>
            <td v-else style="vertical-align:top">{{ item.data }}</td>
          </tr>
        <tr><td></td></tr>
      </table>
    </div>
  </div>

  <div id="email_template_2" v-show="false">
  <!-- <div :id="'email_template_user'+n" v-for="n in this.emails.length/2" v-show="true"> -->
    <!-- <hr  />
    <div style=''>
      <table v-show="pmt === 'Other'">
        <tr colspan="4" >
          <td style="padding-left: 20px;"><p>Please print this invoice and include with your payment to South Dakota Mines:</p>
            <p>SD Mines Student Accounts/Cashier<br />
            501 East St. Joseph St.<br />
            Rapid City, SD 57701-3995</p>
          </td>
        </tr>
      </table>
      <hr /> -->
      <h4>Course Registration Invoice</h4>
      <hr  />
      <p style="font-weight: bold;">{{ items.vfm_firstname.data }} {{ items.vfm_lastname.data }}</p>
      <table>
        <tr>
          <td>Registration Fee:</td>
          <td style="padding: 0 30px">{{ meta.reg_account }}</td>
          <td style="vertical-align:top; text-align: right">{{ Number(meta.reg_amount) | currency }}</td>
        </tr>
        <tr style="border-bottom: 1px solid;">
          <td style="border-bottom: 1px solid;">Service Fee:</td>
          <td style="padding: 0 30px; border-bottom: 1px solid;">{{ meta.svc_account }}</td>
          <td style="vertical-align:top; text-align: right; border-bottom: 1px solid;">{{ Number(meta.svc_amount) | currency }}</td>
        </tr>
        <tr style="border-bottom: double;">
          <td style="vertical-align:top; font-weight: bold; border-bottom: double;">Registration Total:</td>
          <td style=" border-bottom: double;"></td>
          <td style="vertical-align:top; text-align: right; font-weight: bold; border-bottom: double;">{{ Number(meta.tot_amount) | currency }}</td>
        </tr>
      </table>
      <!-- <table>
        <tr><td></td></tr>
          <tr v-for="item in items" :key="item.name">
            <td style="vertical-align:top"><b>{{ item.label }}</b></td>
            <td v-if="item.type === 'currency'" style="vertical-align:top; text-align: right">{{ Number(item.data) | currency }}</td>
            <td v-else style="vertical-align:top">{{ item.data }}</td>
          </tr>
        <tr><td></td></tr>
      </table> -->
      <!-- <table border="0" style="border-collapse: collapse; font: Arial normal 10pt ;" cellpadding="3">
        <tr>
            <td colspan="4">
               <p>{{ meta.policy_label }}: {{ meta.policy_text }}</p>
            </td>
        </tr>
        <tr>
          <td colspan="4">
             <p>This is an automated response. If you have any questions regarding your registration, please contact <a :href="'mailto:'+emails[0].from">{{ emails[0].from_name }}</a>.</p>
          </td>
        </tr>
      </table> -->
    </div>
  </div>

<!-- </div> -->
</template>

<script>
import {
  meta,
  intro,
  results,
  path_hash,
  terms,
  items
} from 'vfm/form-specs'

var timestamp = require('time-stamp');

export default {
  name: 'VueForm',
  computed: {

    csvPath_a: function() {
      var a = [];
      for (var i = 0; i < this.results.csv_files.length; i++) {
        a[i] = {
          path: this.csvPath(i),
          omit: this.results.csv_files[i].omit
        };
      }
      return a;
    },

    confirmURL: function(){
      if (this.pmt == 'Other') return this.results.confirm + 'payment-other.asp'
      else return this.results.confirm + 'payment-online.asp'
    },

    pmt: function(){
      return this.items.vfm_pmt_type.data
    },

//    registration_fee: function() {
//         return this.items.vfm_registration_fee.data = 4000
//     },

    pmt_description: function(){
      return meta.form_name + '\n - Name: ' + this.items.vfm_lastname.data + ', ' + this.items.vfm_firstname.data + '\n - Registration: ' + meta.reg_account + ': ' + meta.reg_amount.toFixed(2) + '\n - CC fee: ' + meta.svc_account + ': ' + meta.svc_amount.toFixed(2)
    }, 

//    tax_fee: function(){
//      let t = this.registration_fee * 0.062
//      t = Math.round(t*100)/100
//      if ( this.pmt != 'PC' ) {
//        return this.items.vfm_tax.data = t
//      }
//      return this.items.vfm_tax.data = 0
//    },

//    total_fee: function(){
//      let t = Math.round((this.tax_fee + this.registration_fee + this.scholarship_contrib)*100)/100
//      return this.items.vfm_fee_total.data = t
//    },

    vfm_combined_name: function() {
      var s = '';
      for (var i = 0; i < this.hiddens.email_from_name.length; i++) {
        if (i !== 0) {
          s += ' '
        }
        if (typeof this.items[this.hiddens.email_from_name[i]] !== 'undefined') {
          s += this.items[this.hiddens.email_from_name[i]];
        } else s += this.hiddens.email_from_name[i];
      }
      return s;
    },
  },

  data() {
    return {
      meta: meta,
      results: results,
      items: items,
      intro: intro,
      path_hash: path_hash,
      terms: terms,
      confirm_template: '',
      csv_files: results.csv_files,
      emails: results.emails,
      file: null,
      pmt_options:[
        { text: 'Credit Card', value: 'CC' },
        { text: 'Other (email: ope@sdsmt.edu)', value: 'Other' },
        // { text: 'State/Federal Payment Card', value: 'PC' },
        // { text: 'Mail-in', value: 'Mail' }
      ]
    }
  },

  filters: {
    currency: function (value) {
      if (!value) return '$0.00'
      return '$'+ Number(value).toFixed(2)
    }
  },

  methods: {
    stampNow() {
      return timestamp('YYYY/MM/DD-HH:mm:ss')
    },

    changeRecipient(){
      let r1_checked = document.getElementById('recipient1').checked;
      let r2_checked = document.getElementById('recipient2').checked;

      if (r1_checked && r2_checked){
        this.emails = results.emails,
        this.csv_files = results.csv_files
        return
      }

      else if (r1_checked){
        this.emails = [results.emails[0], results.emails[2]],
        this.csv_files = [results.csv_files[0]]
      }

      else if (r2_checked){
        this.emails = [results.emails[1], results.emails[3]],
        this.csv_files = [results.csv_files[1]]
      }

      else {
        this.emails = [];
        this.csv_files = [];
      }
    },

    onSubmit(evt) {
      evt.preventDefault();
      this.email_1_body = document.getElementById('email_template_1').innerHTML;
      this.email_2_body = document.getElementById('email_template_2').innerHTML;

      // if (this.emails.length > 2){
      //   this.emails[0].body = document.getElementById('email_template_dept1').innerHTML;
      //   this.emails[1].body = document.getElementById('email_template_dept2').innerHTML;
      //   this.emails[2].body = document.getElementById('email_template_user1').innerHTML;
      //   this.emails[3].body = document.getElementById('email_template_user2').innerHTML;
      // }
      // else{
      //   this.emails[0].body = document.getElementById('email_template_dept1').innerHTML;
      //   this.emails[1].body = document.getElementById('email_template_user1').innerHTML;
      // }
      this.confirm_template = document.getElementById('email_template_2').innerHTML;
      results.stamp = this.stampNow();
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.results.miners !== '') {
            results.action = 'https://interact.sdsmt.edu/not-authorized.asp';
          } else {
            // update
            results.action = 'https://sdmines.sdsmt.edu/cgi-bin/global/send_message_2.cgi';

          }
          this.$nextTick(() => {
            this.$refs.form.submit();
          });

        } else {
          alert('Oops. Please fill in the required fields.');
        }
      });
    },

    getCSVValue(omit, key) {
      if (omit.indexOf(key) === -1) {
        return items[key].name;
      } else return ' - ';
    },

    vfm_init(key) {
      var item = items[key];
      switch (item.type) {
        case 'select':
          if (item.data === '') {
            item.data = null;
          }
          var ph = (item.init.placeholder ? item.init.placeholder : 'Choose an option');
          var top = [{
            text: ph,
            value: null
          }];

          if (typeof item.ctrl !== 'undefined') {
            if (typeof item.ctrl.from !== 'undefined') {
              var key = items[item.ctrl.from];
              var opts = item.init.options[key.data];
              if (typeof opts !== 'undefined') {
                if (opts.indexOf(item.data) === -1) {
                  item.data = null;
                }
                var opts_oa = [];
                for (var i = 0; i < opts.length; i++) {
                  opts_oa[i] = {
                    text: opts[i],
                    value: opts[i]
                  }
                }
                return (top.concat(opts_oa));
              }

              top[0].text = item.ctrl.msg ? item.ctrl.msg : 'Options depend on another field...';
              return (top);
            }
          }
          return (top.concat(item.init.options));
        default:
          return (item.init.placeholder ? item.init.placeholder : ['Enter response here.']);
      }
    },

    csvEnum(name, f_index, i_index) {
      return 'csv_' + (f_index + 1).toString() + '_field_' + (i_index + 1).toString();
    },

    stampEnum(f_index) {
      var max = Object.keys(items).length;
      return 'csv_' + (f_index + 1).toString() + '_field_' + (max + 1).toString();
    },

    csvPath(f_index) {
      var s = '/upload/results/';
      var ref = this.results.csv_files[f_index].file;
      var path = s + this.results.csv_files[f_index].path;
      // if there's a field with the same name as ref, use its data to build the filename
      if (typeof this.items[ref] !== 'undefined') {
        var key = this.items[ref].data;
        if (key !== null && key !== '') {
          var code = this.path_hash[key];
          if (typeof code !== 'undefined') {
            return path + key + '-' + code + '.csv';
          } else console.log('Code not found for hashed value.');
        }
        return path + key + '.csv';
      }
      //else csv_filed[i].file is just a filename string
      return path + ref;
    },

    // clickRecipient( ){
    //
    // },

    radioTrig(key, ctrl, data) {
      var r = '';
      if (typeof ctrl !== 'undefined') {
        for (var j = 0; j < ctrl.length; j++) {
          if (ctrl[j].opener.value === data) {
            for (var i = 0; i < ctrl[j].targets.length; i++) {
              this.items[ctrl[j].targets[i]].show = true;
              r = this.items[ctrl[j].targets[i]].reqs;
              // r += '|required';
              r = ''.concat('required|', r);
              this.items[ctrl[j].targets[i]].reqs = r;
            }
          } else {
            for (var i = 0; i < ctrl[j].targets.length; i++) {
              this.items[ctrl[j].targets[i]].show = false;
              this.items[ctrl[j].targets[i]].data = '';
              r = this.items[ctrl[j].targets[i]].reqs;
              if (r.slice(0, 9) === 'required|') {
                r = r.slice(9);
              }
              // if (r.slice(-9) === '|required') {
              //   r = r.slice(0, (r.length - 9));
              // }
              this.items[ctrl[j].targets[i]].reqs = r;
            }
          }
        }
      }
    } // end radioTrig
  } // end methods
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

div.is-danger {
  margin-top: .2rem;
  color: #B3A369;
  font-size: .8rem;
}

input.is-danger,
select.is-danger {
  border: solid #B3A369 1px;
}

.card-body p {
  font-size: .8rem;
  margin-bottom: 0;
}

.debug {
  font-size: .7em;
  max-width: 30%;
  height: 100%;
  overflow-y: scroll;
  position: fixed;
  border-right: solid 8px #B3A369;
  padding: 1em;
  right: 0;
  top: 0;
  background: rgba(7, 29, 73, 0.6);
  color: white;
  text-align: left;
}

.help-text {
  font-size: .8em;
  font-style: oblique;
  color: #666;
}

.data-debug {
  color: #999;
  font-style: oblique;
}

.jumbotron{
  /* background-color: #071d49;
  color: #fff;  */
  margin-bottom: 20px;
  padding: 2em;
  font-size: .9rem;
  color: #071d49;
  text-align: center;
}

.pmt_summary{
  background-color: #eeeeee;
  margin: 2em 0;
}

.miners {
  display: none;
}

#confirm_template{
  display: none;
}

#email_template_dept{
  display: none;
}

#email_template_user{
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/components/VueForm.vue